import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage'
import * as io from 'socket.io-client';
import {Observable} from "rxjs/Observable";
import {GlobalVariable} from "./global.vars";

@Injectable()
export class SocketService {
  private socketHost = GlobalVariable.SOCKET_URL;
  private socket: any;
  private token: any;
  private isConnected: Boolean;
  constructor (private storage: Storage) {}

  connect(user) {
    this.token = this.storage.get('token').then(token => {

    if( this.isConnected ){
      console.log("already connected");
      return ;
    }
    this.socket = io.connect(this.socketHost, {
      upgrade: false,
      query:'token='+token,
      transports: ['websocket']
    });

    this.socket.on('server:connected', () => {
        this.socket.emit('user:connected',{user : user});
    });
    });
    /*this.socket.on('newMsg',(message)=>{
      console.log(message)
    });
    this.socket.on('newAlert',(message)=>{
      console.log(message)
    });
    this.socket.on('updateAlert',(message)=>{
      console.log(message)
    });
    this.socket.on('connect', ()=>{
      this.isConnected = true;
    })*/
  }

  on(event){
    return new Observable(observer => {
      this.storage.ready().then(()=>{
        this.token = this.storage.get('token').then(token => {
          this.socket.on(event, function (data) {
            observer.next(data);
          });
          return () => {
            this.socket.disconnect();
          };
        });
      });
    });
  }

  emit(event, args){
    this.socket.emit(event, args);
  }
}


// WEBPACK FOOTER //
// ./src/services/socket.service.ts